module.exports = __webpack_public_path__ + "img/energy-efficiency-header.8fedf301.png";